import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { ProductInterface } from '../../products/interfaces/product.interface';
import { BatchProductInterface, CartItem } from '../interfaces/cart.interface';
import { Store } from '@ngrx/store';
import {
  AddCartItem,
  BatchAddCartItem,
  BatchUpdateCartItem,
  UpdateCartItem,
} from '../store/actions/cart.actions';

@Injectable({
  providedIn: 'root',
})
export class CartService {
  public cartOpen$: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(
    false
  );
  public eanOpen$: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(
    false
  );
  public priceActive$: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(
    true
  );
  private cartItems: CartItem[] = [];

  constructor(private store: Store<{ cart: any }>) {
    const cart = this.store.select('cart');
    cart.subscribe((cartItems) => {
      this.cartItems = cartItems;
    });
  }

  addToCart(
    product: ProductInterface,
    collectionId: string,
    quantity: number,
    afterAdd?: () => any,
    afterUpdate?: () => any
  ): void {
    // Erzeugt neues Warenkorbitem
    const newCartItem = {
      quantity,
      price: product.price,
      collectionId,
      productId: product.sku.toString(),
      product,
    } as CartItem;
    // Wenn Artikel noch nicht im Warenkorb ist, wird dieser hinzugefügt.
    // Ansonsten wird der Warenkorb aktualisiert
    if (!this.isInCart(product.sku)) {
      // Fügt Artikel dem Warenkorb hinzu
      this.store.dispatch(AddCartItem(newCartItem));
      if (afterAdd) {
        afterAdd();
      }
    } else {
      // Aktualisiert Warenkorb
      const item = this.cartItems.find(
        (el) => el.product.sku === newCartItem.product.sku
      );
      const didAddProduct = item!.quantity < newCartItem.quantity;

      this.store.dispatch(UpdateCartItem({ item: newCartItem, didAddProduct }));
      if (afterUpdate) {
        afterUpdate();
      }
    }
  }

  batchAddToCart(
    products: BatchProductInterface[],
    afterAdd?: () => any,
    afterUpdate?: () => any
  ) {
    const processed: CartItem[] = [];
    for (let i = 0; i < products.length; i++) {
      const product = products[i];
      processed.push({
        quantity: product.quantity,
        price: product.product.price,
        collectionId: product.collectionId,
        productId: product.product.sku.toString(),
        product: product.product,
      } as CartItem);
    }
    if (processed.some((x) => this.isInCart(x.product.sku))) {
      let item: CartItem | undefined;
      let processedItem: CartItem | undefined;
      for (let i = 0; i < processed.length; i++) {
        item = this.cartItems.find(
          (el) => el.product.sku === processed[i].product.sku
        );
        if (item) {
          processedItem = processed[i];
          break;
        }
      }
      // invariant: if we are in this branch processedItem and item must be defined
      // because the .some inCart resulted in true
      const didAddProduct = item!.quantity < processedItem!.quantity;
      this.store.dispatch(
        BatchUpdateCartItem({ items: processed, didAddProduct })
      );
      if (afterUpdate) {
        afterUpdate();
      }
    } else {
      this.store.dispatch(BatchAddCartItem({ items: processed }));
      if (afterAdd) {
        afterAdd();
      }
    }
  }

  // Prüft ob Artikel bereits im Warenkorb ist
  isInCart(newCartItemID: number): CartItem | undefined {
    return this.cartItems.find((el) => el.product.sku === newCartItemID);
  }
}

